exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-blanco[data-v-730da5d2]{padding-bottom:100px}.button.is-dark.is.rounded.is-bottom-cv[data-v-730da5d2]{margin-top:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-730da5d2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grupos_Componentes/IRGE/CargasGruposIRGE.vue
// module id = 2847
// module chunks = 0